module.exports = __webpack_public_path__ + "static/media/gallery_06.190f8f4d.png";